module.exports = __webpack_public_path__ + "static/media/ChineseNY11_13.a9c21e61.jpg";